import { AfterViewInit, Directive, ElementRef, inject, Input } from "@angular/core";

@Directive({
	selector: "[mydrpfocus]",
	standalone: false,
})
export class FocusDirective implements AfterViewInit {
	private el = inject(ElementRef);

	@Input("mydrpfocus") value: string;

	// Focus to element: if value 0 = don't set focus, 1 = set only focus
	ngAfterViewInit() {
		if (this.value === "0") {
			return;
		}
		this.el.nativeElement.focus();
	}
}
